import styled from 'astroturf/react'
import { IconMessageQuestion } from '@calendly/ui/components/glyphs/IconMessageQuestion'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { SwitchInput } from '@calendly/ui/components/switch-input'
import { Tooltip } from '@calendly/ui/components/tooltip'
const spaceSmall = 'var(--spacing-0-5x, 0.5rem)'
const spacing0x = 'var(--spacing-0x, 0)'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorIconStandard = 'var(--colorIconStandard, var(--coreColorNeutral800))'
const colorStrokeStrong = 'var(--colorStrokeStrong, var(--coreColorNeutral600))'

import { useProductRefreshPreviewToggle } from './useProductRefreshPreviewToggle'
import _Root from "ProductRefreshPreviewToggle-Root.module.css!=!astroturf/inline-loader?style=1!/app/frontend/product_refresh/ProductRefreshPreviewToggle.js?styleId=Root";
import _HelpIconWrapper from "ProductRefreshPreviewToggle-HelpIconWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/product_refresh/ProductRefreshPreviewToggle.js?styleId=HelpIconWrapper";


const Root = /*#__PURE__*/styled('div', null, {
  displayName: "Root",
  styles: _Root
})

const HelpIconWrapper = /*#__PURE__*/styled('span', null, {
  displayName: "HelpIconWrapper",
  styles: _HelpIconWrapper
})

const HELP_TOOLTIP_TEXT = 'Brand 2026 theme preview. Currently in active development.'

export const ProductRefreshPreviewToggle = ({ showBorder = false }) => {
  const { checked, onChange } = useProductRefreshPreviewToggle()

  return (
    <Root showBorder={showBorder} data-testid="app-layout-debug-switch">
      <label>
        <SwitchInput
          aria-label="Brand 2026 theme"
          checked={checked}
          onChange={onChange}
        />
      </label>
      <Tooltip text={HELP_TOOLTIP_TEXT} zIndex={350}>
        <HelpIconWrapper>
          <UiIcon icon={IconMessageQuestion} size="small" color={colorIconStandard} />
        </HelpIconWrapper>
      </Tooltip>
    </Root>
  )
}
